<template>
  <b-card-footer>
    <b-row class="my-1">
      <b-col sm="4">
        <label :for="'isOnReports-' + questionSection.question_id">
          Show by default on Reports:
        </label>
      </b-col>
      <b-col sm="8">
        <b-form-checkbox
          :id="'isOnReports-' + questionSection.question_id"
          v-model.number="questionSection.is_default_on_results"
          :value="1"
          :unchecked-value="0"
        />
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col sm="4">
        <label :for="'isAvailableOnReports-' + questionSection.question_id">
          Allow selection as measure on Reports:
        </label>
      </b-col>
      <b-col sm="8">
        <b-form-checkbox
          :id="'isAvailableOnReports-' + questionSection.question_id"
          v-model.number="questionSection.is_available_on_results"
          :value="1"
          :unchecked-value="0"
        />
      </b-col>
    </b-row>
    <template v-if="isPrimary">
      <b-row class="my-1">
        <b-col sm="4">
          <label :for="'isOnDashboard-' + questionSection.question_id">
            Display On Dashboard:
          </label>
        </b-col>
        <b-col sm="8">
          <b-form-checkbox
            :id="'isOnDashboard-' + questionSection.question_id"
            v-model.number="questionSection.is_on_dashboard"
            :value="1"
            :unchecked-value="0"
          />
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="4">
          <label :for="'dashboardDisplayOrder-' + questionSection.question_id">
            Dashboard Display Order:
          </label>
        </b-col>
        <b-col sm="8" role="group">
          <b-form-input
            type="number"
            :id="'dashboardDisplayOrder-' + questionSection.question_id"
            :value="displayOrder"
            :state="validateState('displayOrder')"
            @change="setDisplayOrder"
          />
          <b-form-invalid-feedback>
            {{ displayOrderInvalidFeedback }}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
    </template>
    <b-row class="my-1">
      <b-col sm="4">
        <label :for="'isIncludedInDefaultReport-' + questionSection.question_id">
          Include In Default Report:
        </label>
      </b-col>
      <b-col sm="8">
        <b-form-checkbox
          :id="'isIncludedInDefaultReport-' + questionSection.question_id"
          v-model.number="questionSection.is_included_in_default_report"
          :value="1"
          :unchecked-value="0"
        />
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col sm="4">
        <label :for="'reportOrder-' + questionSection.question_id">
          Report Order:
        </label>
      </b-col>
      <b-col sm="8" role="group">
        <b-form-input
          type="number"
          :id="'reportOrder-' + questionSection.question_id"
          :value="reportOrder"
          :state="validateState('reportOrder')"
          @change="setReportOrder"
          min="0"
          max="255"
        />
        <b-form-invalid-feedback>
          {{ reporterOrderInvalidFeedback }}
        </b-form-invalid-feedback>
      </b-col>
    </b-row>
  </b-card-footer>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minValue, required } from 'vuelidate/lib/validators';

export default {
  name: 'QuestionnaireParamsForm',
  mixins: [validationMixin],
  props: {
    questionSection: {
      type: Object,
      required: true,
    },
    isPrimary: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      displayOrder: this.questionSection.dashboard_display_order || 0,
      reportOrder: this.questionSection.report_order || 0,
    };
  },
  validations: {
    displayOrder: {
      required,
      minValue: minValue(0),
    },
    reportOrder: {
      minValue: minValue(0),
    },
  },
  computed: {
    displayOrderInvalidFeedback: function() {
      if (!this.$v.displayOrder.minValue) {
        return 'Display order should be 0 or greater.';
      }
      return 'This field is required';
    },
    reporterOrderInvalidFeedback: function() {
      if (!this.$v.reportOrder.minValue) {
        return 'Reporter order should be 0 or greater.';
      }
      return 'This field is required';
    },
  },
  methods: {
    setDisplayOrder: function (val) {
      this.displayOrder = val;
      this.$v.displayOrder.$touch();
      this.$nextTick(() => {
        if (!this.$v.displayOrder.$error) {
          this.questionSection.dashboard_display_order = this.displayOrder;
        }
      });
    },
    setReportOrder: function (val) {
      this.reportOrder = val;
      this.$v.reportOrder.$touch();
      this.$nextTick(() => {
        if (!this.$v.reportOrder.$error) {
          this.questionSection.report_order = !this.reportOrder ? 0 : this.reportOrder;
        }
      });
    },
    validateState: function(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
  },
  watch: {
    'questionSection.is_default_on_results': function (newVal) {
      if (newVal === 1 && this.questionSection.is_available_on_results === 0) {
        this.questionSection.is_available_on_results = 1;
      }
    },
    'questionSection.is_available_on_results': function (newVal) {
      if (newVal === 0 && this.questionSection.is_default_on_results === 1) {
        this.questionSection.is_default_on_results = 0;
      }
    },
  },
};
</script>

<style scoped></style>
